// `/hr` index — picks between two GENUINELY DIFFERENT overviews by viewport.
//
// This is the one place in the tenant SPA where a viewport branch renders
// different information rather than the same information differently, and
// that is deliberate. `HrDashboard` is 778 lines of dense professional
// case-management surface: bucket tiles, the top-50 unacknowledged flag feed,
// per-manager load, and three privacy-gated aggregate tiles whose own
// comments flag the k-anonymity / PII-boundary logic as privacy-critical.
// Cramming that onto a phone would be a poor experience AND would mean
// re-touching that logic for what is otherwise a chrome change. So a phone
// gets `HrCompactOverview` — the four case-bucket counts, from the same
// endpoint — and is told plainly where to find the rest.
//
// Safe to branch here because neither side holds local state worth losing:
// `HrDashboard` is queries only, and `HrCompactOverview` reads one. Contrast
// `ManagerAskMaeve`, where a branch was a data-loss bug.

import { useMediaQuery, TAILWIND_MD_MAX_WIDTH_QUERY } from '@/lib/use-media-query.ts';
import { HrDashboard } from '@/routes/HrDashboard.tsx';
import { HrCompactOverview } from '@/components/HrCompactOverview.tsx';

export function HrOverview() {
  const isPhone = useMediaQuery(TAILWIND_MD_MAX_WIDTH_QUERY);
  return isPhone ? <HrCompactOverview /> : <HrDashboard />;
}
